import {TRANSLATION, Yup} from '@/imports-files/pages/career/view-job';

const phoneRegex = /^\+?[\d\s]+$/;
export const APPLICATION_FILE_SIZE_LIMIT = 25000000;
export const CV_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf', 'ppt']
export const OTHER_FILE_EXTENSIONS = ['pdf', 'doc', 'docx', 'rtf', 'ppt', 'jpeg', 'jpg', 'png']


export const INITIAL_VALUES = {
    client_candidate: {
                        name                : '',
                        email               :	'',
                        contact_no          :	'',
                        location            : '',
                        assign              :'',
                        sourced_option      :'',
                        agency_id           :'',
                        agency_user_email   :'',  
                        social_media_detail_attributes: {
                                                            linkedin_url : '',
                                                            portfolio_url : ''
                                                        },
                        resume_attributes : {
                                                file_id: '',
                                                file_type: '',
                                                file: '',
                                                file_name: '',
                                                _destroy: false
                                            },
                        other_files_attributes: [],
                        agency_domain: '',
                        introduction: '',
  }
}

export function validationSchema(agencyUsers){
  return Yup.object().shape({
  client_candidate: Yup.object().shape({
    // name: Yup.string().required(TRANSLATION('errors:required')),
    first_name: Yup.string().required(TRANSLATION('errors:required')),
    last_name: Yup.string().required(TRANSLATION('errors:required')),
    contact_no: Yup.string()
        .matches(phoneRegex, TRANSLATION('errors:no_special_char'))
        .min(8,  TRANSLATION('errors:contact_short'))
        .max(20, TRANSLATION('errors:contact_long')),
    email: Yup.string().required(TRANSLATION('errors:required')).email(TRANSLATION('errors:invalid_email')),
    social_media_detail_attributes:Yup.object().shape({
                                                        linkedin_url: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, TRANSLATION('errors:invalid_url')),
                                                        portfolio_url: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, TRANSLATION('errors:invalid_url'))
                                                      }),
    resume_attributes: Yup.object().shape({
                                            file_name: Yup.string()
                                          }),
    sourced_option: Yup.string(),
    // agency_domain: Yup.string()
    agency_id: Yup.string().when("sourced_option", {
      is: (sourced_option) => sourced_option == 'Agency',
      then: Yup.string().required(TRANSLATION('errors:required')).nullable(),
      otherwise: Yup.string().notRequired()
    }),
    agency_user_email: Yup.string().when(["sourced_option"], {
      is: (sourced_option) => sourced_option == 'Agency',
      then: Yup.string().required(TRANSLATION('errors:required')).email(TRANSLATION('errors:invalid_email')).nullable().test("user_email_issue", ('errors:email_select_from_dropdown'), function(value) {
        if(value){
          return agencyUsers.find((x) => x.email == value)
        }
        else  {
          return true
        }
      }),
      otherwise: Yup.string().notRequired()
    }),
    job_board_integration_attributes: Yup.object().when("sourced_option",{
      is: (sourced_option) => ["Job Board", "Social"].includes(sourced_option),
      then: Yup.object().shape({
        _destroy: Yup.boolean(),
        integration_id: Yup.string().nullable(true).required(TRANSLATION('errors:required'))
      })
    }),
  }),
 })
}


export const add_candidate_initial_values = () => {
  return { client_candidate: {
    name                : '',
    first_name          : '',
    last_name           : '',
    email               :	'',
    contact_no          :	'',
    location            : '',
    assign              :'',
    sourced_option      :'',
    agency_id           :'',
    agency_user_email   :'',  
    social_media_detail_attributes: {
                                        linkedin_url : '',
                                        portfolio_url: '',
                                    },
    resume_attributes : {
                            file_id: '',
                            file_type: '',
                            file: '',
                            file_name: '',
                            _destroy: false
                        },
    other_files_attributes: [],
    agency_domain: '',
    job_board_integration_attributes: {
      integration_id: '',
      integration_type: 'Integration'
    },
    introduction: ''
    }
  }
} 
export const QUESTIONS = [{
                            question: 'Tell us more about the candidate?',
                            duration: 120,
                            description: '',
                            attempts: 3
                        }]

export const VALIDATION_SCHEMA = (t) => Yup.object().shape({
  client_candidate: Yup.object().shape({
    // name: Yup.string().required(TRANSLATION('errors:required')),
    first_name: Yup.string().required(t('errors:required')),
    last_name: Yup.string().required(t('errors:required')),
    contact_no: Yup.string()
        .matches(phoneRegex, t('errors:no_special_char'))
        .min(8, t('errors:contact_short'))
        .max(20,t('errors:contact_long')),
    email: Yup.string().required(t('errors:required')).email(t('errors:invalid_email')),
    social_media_detail_attributes:Yup.object().shape({
                                                        linkedin_url: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url'),
                                                        portfolio_url: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, 'Please enter correct url')
                                                      }),
    resume_attributes: Yup.object().shape({
                                            file_name: Yup.string()
                                          }),
    sourced_option: Yup.string(),
    agency_domain: Yup.string(),
    agency_id: Yup.string().when("sourced_option", {
      is: (sourced_option) => sourced_option == 'Agency',
      then: Yup.string().required(t('errors:required')).nullable(),
      otherwise: Yup.string().notRequired()
    }),
    agency_user_email: Yup.string().when(["sourced_option", "agency_domain"], {
      is: (sourced_option, agency_domain) => sourced_option == 'Agency',
      then: Yup.string().required(t('errors:required')).email(t('errors:invalid_email')).nullable().test("user_domain_issue", "User domain should match with agency domain", function(value) {
        if(value){
          let agency_domain = this.parent.agency_domain
          let user_email_domain  = value?.split("@")[1];
          var user_domain = user_email_domain?.split(".")[0];
          return user_domain == agency_domain
        }
        else  {
          return true
        }
      }),
      otherwise: Yup.string().notRequired()
   }),
  }),
 })
